import { coerceBooleanProperty, coerceCssPixelValue, coerceNumberProperty } from '@angular/cdk/coercion';

// Define a property that can also returned by called function
export type FunctionProp<T> = (...args: any[]) => T; // tslint:disable-line:no-any

export function toBoolean(value: boolean | string): boolean {
  return coerceBooleanProperty(value);
}

export function toNumber<D>(value: number | string, fallback: D): number | D {
  return coerceNumberProperty(value, fallback);
}

export function toCssPixel(value: number | string): string {
  return coerceCssPixelValue(value);
}

// Get the funciton-property type's value
export function valueFunctionProp<T>(prop: FunctionProp<T>, ...args: any[]): T {
  // tslint:disable-line: no-any
  return typeof prop === 'function' ? prop(...args) : prop;
}

// tslint:disable-next-line: no-any
function propDecoratorFactory<T, D>(name: string, fallback: (v: T) => D): (target: any, propName: string) => void {
  // tslint:disable-next-line: no-any
  function propDecorator(target: any, propName: string): void {
    const privatePropName = `$$__${propName}`;

    if (Object.prototype.hasOwnProperty.call(target, privatePropName)) {
      console.warn(`The prop "${privatePropName}" is already exist, it will be overrided by ${name} decorator.`);
    }

    Object.defineProperty(target, privatePropName, {
      configurable: true,
      writable: true,
    });

    Object.defineProperty(target, propName, {
      get(): string {
        return this[privatePropName]; // tslint:disable-line:no-invalid-this
      },
      set(value: T): void {
        this[privatePropName] = fallback(value); // tslint:disable-line:no-invalid-this
      },
    });
  }

  return propDecorator;
}

/**
 * ä½¿ç¨toBooleanè®©ä¸ä¸ªå±æ§èªå¨å°è®¾ç½®get/setå±æ§
 *
 * ä¸ºä½ä¸åªæ¯ä½¿ç¨ @InputBoolean éè¦å ä¸ @Input ? å ä¸ºAOT éè¦ @Input æ¾ç¤ºå°å£°æåºæ¥
 *
 * @howToUse
 * ```
 * @Input() @InputBoolean() visible: boolean = false;
 *
 * // å°±åè¿æ ·:
 * // @Input()
 * // get visible() { return this.__visibile; }
 * // set visible(value) { this.__visible = value; }
 * // __visible = false;
 * ```
 */
export function InputBoolean(): any {
  // tslint:disable-line: no-any
  return propDecoratorFactory('InputBoolean', toBoolean);
}

export function InputCssPixel(): any {
  // tslint:disable-line: no-any
  return propDecoratorFactory('InputCssPixel', toCssPixel);
}
